import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Kanban, BookOpen, BarChart2, DollarSign, Activity, ChevronLeft, ChevronRight, ListChecks, UserCog, List } from 'lucide-react';
import { useState } from 'react';
import { cn } from '../../lib/utils';

const baseLinks = [
  { to: '/',          icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/leads',     icon: List,            label: 'Leads' },
  { to: '/pipeline',  icon: Kanban,          label: 'Pipeline' },
  { to: '/sequences', icon: ListChecks,      label: 'Sequences' },
  { to: '/revenue',   icon: DollarSign,      label: 'Revenue' },
  { to: '/kb',        icon: BookOpen,        label: 'Knowledge Base' },
  { to: '/team',      icon: BarChart2,       label: 'Team' },
  { to: '/activity',  icon: Activity,        label: 'Activity' },
];

const adminLinks = [
  { to: '/users', icon: UserCog, label: 'Users' },
];

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const links = user.role === 'admin' ? [...baseLinks, ...adminLinks] : baseLinks;

  return (
    <aside className={cn('flex flex-col bg-zinc-900 text-zinc-100 transition-all duration-200 shrink-0', collapsed ? 'w-14' : 'w-56')}>
      <div className="flex items-center justify-between px-3 py-4 border-b border-zinc-700">
        {!collapsed && <span className="font-semibold text-sm tracking-wide text-white">Matply CRM</span>}
        <button onClick={() => setCollapsed(c => !c)} className="p-1 rounded hover:bg-zinc-700 ml-auto">
          {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </button>
      </div>

      <nav className="flex-1 py-2 space-y-0.5 overflow-y-auto">
        {links.map(({ to, icon: Icon, label, end }) => (
          <NavLink key={to} to={to} end={end}
            className={({ isActive }) =>
              cn('flex items-center gap-3 px-3 py-2 text-sm rounded mx-1 transition-colors',
                isActive ? 'bg-indigo-600 text-white' : 'text-zinc-400 hover:bg-zinc-800 hover:text-white')
            }>
            <Icon size={16} className="shrink-0" />
            {!collapsed && <span>{label}</span>}
          </NavLink>
        ))}
      </nav>

    </aside>
  );
}
